import { render, staticRenderFns } from "./edit-label-dialog.vue?vue&type=template&id=2e74eee0&scoped=true&"
import script from "./edit-label-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-label-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74eee0",
  null
  
)

export default component.exports